import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from 'react-tooltip';
import { getStatus } from "../../../services/Helper";


// extraColumns ([{ key, header, render(order) }]) and renderActions(order) are
// optional, so the Escalations panel can reuse this table.
const DataTable = ({ orders, extraColumns = [], renderActions }) => {
  const isPanel = extraColumns.length > 0;
  const fixedWidth = (widthClass) => (isPanel ? '' : ` ${widthClass}`);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', options).replace(',', ' at');
  };
  return (
    <>
      <div className="">
        <table className={`table table-hover align-middle table-nowrap mb-0 table-borderless${isPanel ? ' order-panel-table' : ''}`}>
          <thead className="table-light">
            <tr>
              <th className={`align-middle${fixedWidth('w-20')} order-panel-nowrap`} scope="col">
                #ID
              </th>
              <th className={`align-middle${fixedWidth('w-20')}`} scope="col">
                Customer
              </th>
              <th className={`align-middle${fixedWidth('w-30')} order-panel-products`} scope="col">
                Products
              </th>
              <th className="align-middle" scope="col">
                Total
              </th>
              <th className="align-middle" scope="col">
                Status
              </th>
              <th className="align-middle order-panel-nowrap" scope="col">
                Order Date
              </th>
              {extraColumns.map((column) => (
                <th key={column.key} className={`align-middle ${column.className || ''}`} scope="col">
                  {column.header}
                </th>
              ))}
              <th className="align-middle" scope="col"> </th>
              <th className="align-middle" scope="col"></th>
              <th className="align-middle text-center" scope="col">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={index}>
                <td className="order-panel-nowrap">
                  <Link to={`/orders/${order._id}`}>{order.orderId}</Link>
                </td>
                <td className="text-body-emphasis">
                  {order.buyerInfo.fullname
                    ? order.buyerInfo.fullname
                    : order.buyerInfo.username}{" "}
                    <span style={{fontSize:'12px',fontWeight:'200'}}>({order?.buyerInfo?.username})</span>
                </td>
                <td className="text-body-emphasis">
                  {order.products && order.products.length > 0 ? (
                    <>
                  {order.products.map((product, index) => (
                    <div key={index} style={{ borderBottom: index !== order.products.length - 1 ? '1px dashed #e5e5e2' : 'none'}}>
                      <p className="p-0 m-0" style={{fontSize:'11px'}}>{product.title}</p>
                    </div>
                  ))}

                    </>
                  ) : (
                    <span>No products found</span>
                  )}
                </td>
                <td>£{Number(order.total || 0).toFixed(2)}</td>
                <td>
                <span
                  className={`badge rounded-lg rounded-pill alert py-3 px-4 mb-0 border-0 text-capitalize fs-12 ${getStatus(order.status, order.isPGD).class}`}
                >
                  {getStatus(order.status, order.isPGD).text}
                </span>
                </td>
                <td className="order-panel-nowrap">{formatDate(order.createdAt)} </td>
                {extraColumns.map((column) => (
                  <td key={column.key} className={column.className}>{column.render(order)}</td>
                ))}
                <td>
                    <>
                    <div className="d-flex">
                      {order.notification === 1 &&
                        <div style={{margin:'10px'}}>
                          <i class="fa fa-circle text-danger-glow-green blink"></i>
                        </div>
                      }
                      {order.anomalyVisible && 
                        <div style={{margin:'10px'}}>
                          <i class="fa fa-circle text-danger-glow-red blink"></i>
                        </div>
                      }
                      {order.isRepeat && 
                        <div style={{margin:'10px'}}>
                          <i class="fa fa-circle text-danger-glow-purple blink"></i>
                        </div>
                      }
                      {order.isCarehome && 
                        <div style={{margin:'10px'}}>
                           <i class="fa fa-circle text-danger-glow-orange blink" title="Order from care home"></i>
                        </div>
                      }

                    </div>
                    </>
                  
                </td>
                <td>
                  {order.isNotes && 
                    <>
                      <i className="fas fa-sticky-note text-primary" data-tooltip-id={`notesTooltip-${index}`}></i>
                      {isPanel ? (
                        <Tooltip id={`notesTooltip-${index}`} place="top" opacity={1} noArrow className="order-notes-tooltip">
                          <div className="order-notes-header">
                            <span>Notes</span>
                            <span className="order-notes-count">{order.notes.length}</span>
                          </div>
                          {order.notes.map((note, noteIndex) => (
                            <div className="order-notes-item" key={note._id || noteIndex}>
                              <span className="order-notes-title">{note.title}</span>
                              <span className="order-notes-text">{note.description}</span>
                              <span className="order-notes-date">{formatDate(note.createdAt)}</span>
                            </div>
                          ))}
                        </Tooltip>
                      ) : (
                      <Tooltip id={`notesTooltip-${index}`} place="top" effect="solid" className="custom-tooltip">
                              {order.notes.map((note, noteIndex) => (
                                <>
                                  <div className=" mt-4" key={noteIndex}>
                                          <p className="m-0 p-0 note-title">{note.title}</p>
                                          <p className=" m-0 p-0 note-date">{note.description} </p>
                                          <div className="note-footer mt-4 mb-4">
                                              <p className="m-0 p-0 note-date">  
                                                {formatDate(note.createdAt)} 
                                              </p>
                                          </div>
                                  </div>
                                  <hr />
                                  </>
                              ))}
                      </Tooltip>
                      )}
                    </>

                  }
                </td>
                <td className="text-center">
                  <div className="d-flex flex-nowrap justify-content-center order-panel-actions">
                    <Link to={`/orders/${order._id}`}
                      className="btn btn-outline-primary py-4 fs-13px btn-xs me-4"
                      title={isPanel ? 'View order' : undefined}
                    >
                      <i className="fa fa-info"></i>
                    </Link>
                    {renderActions && renderActions(order)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default DataTable;
